<template>
    <div class="login" @keydown.enter="handleSubmit">
        <div class="register-con" v-if="type==2">
            <el-card :bordered="false">
                <p slot="header">
                    <i class="log-in"></i>
                    扫码关注，注册
                </p>
                <div class="form-con">
                    <div style="text-align: center;">
                        <img src="../assets/qrcode_for.jpg">
                        <div></div>
                    </div>
                    <p class="login-tip" style="text-align: right;"><a @click="type=1">去登录</a></p>
                </div>
            </el-card>
        </div>
        <div class="login-con" v-if="type==1">
            <el-card :bordered="false">
                <p slot="header">
                    <i class="log-in"></i>
                    欢迎仓库管理员登录【Shopee助手】
                </p>
                <div class="form-con">
                    <el-form ref="loginForm" :model="form" :rules="rules">
                        <el-form-item prop="loginName">
                            <el-input size="small" v-model="form.userName" placeholder="请输入用户名">
                                <span slot="prepend">
                                </span>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" v-model="form.password" placeholder="请输入密码">
                                <span slot="prepend">
                                </span>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" :loading="loading" @click="handleSubmit" style="width: 100%" type="primary" long>登录</el-button>
                        </el-form-item>
                        <div></div>
                    </el-form>
                </div>
                <el-dropdown transfer trigger="click" @command="itemNetClick">
                    <a href="javascript:void(0)">
                        <span class="main-user-name">
                            {{ netName }}</span>
                        <i class="arrow-down-b"></i>
                    </a>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="KhNet">香港线路</el-dropdown-item>
                        <el-dropdown-item command="CnNet" divided>国内线路</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-card>
        </div>
    </div>
</template>
<script>
import api from "@/api/api"
import axios from 'axios'
export default {
    name: 'Login',
    data() {
        return {
            type: 1,
            netName: "",
            loading: false,
            form: {
                userName: '',
                password: '',
                code: '123456'
            },
            rules: {
                userName: [
                    { required: true, message: '账号不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ]
            }
        }
    },
    mounted: function() {

        this.netName = localStorage.netName;
        if (this.netName == undefined) {
            localStorage.setItem("netName", "国内线路");

        }
    },
    methods: {
        itemNetClick: function(name) {

            if (name == 'KhNet') {
                localStorage.setItem("netName", "香港线路");

            } else {

                localStorage.setItem("netName", "国内线路");

            }
            this.netName = localStorage.netName;
        },
        handleSubmit: function() {
            //console.log(process.env.VUE_APP_APPKEY);
            var me = this;
            me.$refs.loginForm.validate((valid) => {
                if (valid) {
                    me.loading = true;
                    me.$store
                        .dispatch("userLogin", me.form)
                        .then(res => {
                            me.loading = false;
                            if (res.status == 0) {
                                me.$store.commit('clearAllTags');
                                me.$router.push("/index");
                            } else {
                                me.errorMessage(res.info);
                            }
                        }).catch(error => {

                            me.restInfo();
                            me.errorMessage("登录异常" + error);
                            me.loading = false;
                        });
                }
            });


        },
        restInfo: function() {
            this.form.userName = "";
            this.form.password = "";
        }
    },
    components: {

    }
}
</script>
<style scoped>
html,
body {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    overflow: hidden;
}

.login {
    width: 100%;
    height: 100%;
    background-image: url('https://file.iviewui.com/iview-admin/login_bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;

}

.login .login-con {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 350px;

}

.login .register-con {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 350px;


}


.login .login-con-header {
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    padding: 30px 0;
}

.login .form-con {
    padding: 0 0 0 0;
}

.login .login-tip {
    font-size: 10px;
    text-align: center;
    color: #c3c3c3;
}

.ivu-card {
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    position: relative;
    transition: all .2s ease-in-out;
}

.ivu-card-head {
    border-bottom: 1px solid #e9eaec;
    padding: 14px 16px;
    line-height: 1;
}

.ivu-card-body {
    padding: 16px;
}
</style>